import { render, staticRenderFns } from "./ManagementHistory.vue?vue&type=template&id=60882493"
import script from "./ManagementHistory.vue?vue&type=script&lang=js"
export * from "./ManagementHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports